import { set, get } from 'lodash-es'

import MUTATION_TYPES from './mutation-types'
import CONSTANTS from './constants'
import API_CONSTANTS from '@/js/helper/api-constants.js'

export default {
  [MUTATION_TYPES.DECREASE_UNREAD_TOTAL]: state => {
    const currentUnreadTotal = get(
      state,
      [MUTATION_TYPES.MESSAGES.dataKey, API_CONSTANTS.META.TYPE, API_CONSTANTS.MESSAGE.UNREAD],
      0,
    )
    set(
      state,
      [MUTATION_TYPES.MESSAGES.dataKey, API_CONSTANTS.META.TYPE, API_CONSTANTS.MESSAGE.UNREAD],
      currentUnreadTotal - 1,
    )
  },
  [MUTATION_TYPES.SET_MESSAGE_PREVIEW_DATA]: (state, data) => {
    set(state, CONSTANTS.MESSAGE_PREVIEW_DATA, data)
  },
}
